export const CONTROL_MODE_LOCATION = 'location';
export const CONTROL_MODE_KEYWORD = 'keyword';
export const CONTROL_MODE_REGEX = 'regex';
export const CONTROL_MODE_FORMAT = 'format';
export const CONTROL_MODE_VALIDATE = 'validate';
export const ANNOTATION_TYPE_LOCATION = 'location';
export const ANNOTATION_TYPE_KEYWORD = 'keyword';
export const ANNOTATION_TYPE_REGEX = 'regex';
export const ANNOTATION_TYPE_FORMAT = 'format';
export const ANNOTATION_TYPE_VALIDATE = 'validate';
export const CORNERS = ['topLeft', 'middleTop', 'topRight', 'bottomRight', 'middleBottom', 'bottomLeft'];
export const DEFAULT_MAXIMUM_DOCUMENT_WIDTH = 1200;
export const DEFAULT_CROPPER_PREVIEW_SIZE = 120;
export const TEMPLATE_NAME_MIN_CHARS = 4;
export const TEMPLATE_NAME_MAX_CHARS = 32;
export const TEMPLATE_DESCRIPTION_MAX_CHARS = 256;
export const FIELD_NAME_MIN_CHARS = 1;
export const FIELD_NAME_MAX_CHARS = 32;
